<template>
  <div id="SectionClimateStandards">
    <UIContainer class="SectionClimateStandards__container">
      <template #right>
        <img
          class="SectionClimateStandards__image"
          src="../assets/climateStandards/carbonFootprint.avif"
          alt="Carbon footprint scheme"
          loading="lazy"
        />
      </template>

      <template #left>
        <div class="SectionClimateStandards__content">
          <SectionTitle titleSize="sm">
            <template #title>
              Navigate the new B Corp climate standards with confidence
            </template>

            <template #description>
              The new B Corp standards are here, and the requirements for
              climate action are changing. What was once voluntary is now
              mandatory for large B Corps (250+ FTE) re-certifying after July
              2025. <br />
              <br />To maintain your certification, you will be required to:
            </template>
          </SectionTitle>

          <div class="SectionClimateStandards__features">
            <div
              class="SectionClimateStandards__feature"
              v-for="feature in features"
              :key="feature"
            >
              <UIIcon
                class="SectionClimateStandards__feature-icon"
                name="checkCircle"
              />
              <span>{{ feature }}</span>
            </div>
          </div>

          <div class="SectionClimateStandards__cta">
            <UIButton size="xl" theme="primary" :to="{ name: 'Contact' }">
              Book a B Corp strategy call
            </UIButton>
          </div>
        </div>
      </template>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
import UIButton from '@/views/components/ui/buttons/UIButton.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import UIIcon from '@/views/components/ui/icons/UIIcon.vue'

const features = [
  'Measure a full-scope carbon footprint',
  'Set a science-based Net Zero target (SBTi-aligned)',
  'Develop and share a credible Climate Transition Plan (CTP)',
]
</script>

<style lang="scss" scoped>
#SectionClimateStandards {
  position: relative;

  .SectionClimateStandards__header-container {
    margin-bottom: 2rem;
    padding-bottom: 0;

    @include md {
      max-width: 48rem;
      text-align: center;
      margin-bottom: 6rem;
    }
  }

  .SectionClimateStandards__container {
    padding-top: 0;
  }

  .SectionClimateStandards__image {
    display: none;
    width: 100%;

    @include md {
      display: block;
      padding-left: 2rem;
    }
  }

  .SectionClimateStandards__content {
    padding: 1rem 0;

    @include md {
      padding: 1rem 4rem 1rem 0;
    }
  }

  .SectionClimateStandards__title {
    @include font-size-20px();
    font-weight: 600;
    line-height: 1.2;
    color: $color-ui-gray-cool-900;
    margin-bottom: 1rem;

    @include md {
      @include font-size-24px();
    }
  }

  .SectionClimateStandards__features {
    display: grid;
    gap: 1.25rem;
    padding-left: 1rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .SectionClimateStandards__feature {
    @include font-size-18px();
    display: flex;
    align-items: center;
    color: $color-ui-gray-cool-600;
    gap: 0.75rem;
  }

  .SectionClimateStandards__feature-icon {
    --size: 1.75rem;
  }

  .SectionClimateStandards__cta {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
}
</style>
